import { CrimpCloudPartner, CrimpCloudPartnerDeleteReq, CrimpCloudPartnerListRequest, CrimpCloudPartnerRequest } from '@ct-asm/asm-asset-management-typescript-sdk/dist/src/crimp-cloud-partners/crimp_cloud_partner_request';
import { Action } from '@ngrx/store';

export enum CrimpCloudPartnerActionTypes {
  LIST_LOGGED_IN_PARTNER_COMPANY = '[Dashboard Page] List Crimp Cloud Partners',
  LIST_LOGGED_IN_PARTNER_COMPANY_SUCCESS = '[Dashboard Page] List Crimp Cloud Partners Success',
  LIST_LOGGED_IN_PARTNER_COMPANY_FAILED = '[Dashboard Page] List Crimp Cloud Partners Failed',

  LIST_CRIMP_CLOUD_PARTNERS = '[Partner Edit Page] List Crimp Cloud Partners',
  LIST_CRIMP_CLOUD_PARTNERS_SUCCESS = '[Partner Edit Success] List Crimp Cloud Partners Success',
  LIST_CRIMP_CLOUD_PARTNERS_FAILED = '[Partner Edit  Fail] List Crimp Cloud Partners Failed',

  CREATE_CRIMP_CLOUD_PARTNERS = '[Partner Edit Page] Create Crimp Cloud Partners',
  CREATE_CRIMP_CLOUD_PARTNERS_SUCCESS = '[Partner Edit Success] Create Crimp Cloud Partners Success',
  CREATE_CRIMP_CLOUD_PARTNERS_FAILED = '[Partner Edit  Fail] Create Crimp Cloud Partners Failed',

  DELETE_CRIMP_CLOUD_PARTNERS = '[Partner Edit Page] Delete Crimp Cloud Partners',
  DELETE_CRIMP_CLOUD_PARTNERS_SUCCESS = '[Partner Edit Success] Delete Crimp Cloud Partners Success',
  DELETE_CRIMP_CLOUD_PARTNERS_FAILED = '[Partner Edit  Fail] Delete Crimp Cloud Partners Failed',

  RESET_CRIMP_CLOUD_PARTNERS = 'Reset Crimp Cloud Partners',
  RESET_PARTNER_CREATION_FLAGS = 'Reset partner creation flags',
  RESET_PARTNER_DELETION_FLAGS = 'Reset partner deletion flags',
  RESET_CRIMP_CLOUD_PARTNER_LIST = 'Reset crimp cloud partner list'
}

export class ListCrimpCloudPartners implements Action {
  readonly type = CrimpCloudPartnerActionTypes.LIST_CRIMP_CLOUD_PARTNERS;
  constructor(public payload: CrimpCloudPartnerListRequest) { }
}

export class ListCrimpCloudPartnersSuccess implements Action {
  readonly type = CrimpCloudPartnerActionTypes.LIST_CRIMP_CLOUD_PARTNERS_SUCCESS;

  constructor(public payload: any) { }
}

export class ListCrimpCloudPartnersFailed implements Action {
  readonly type = CrimpCloudPartnerActionTypes.LIST_CRIMP_CLOUD_PARTNERS_FAILED;

  constructor(public payload: any) { }
}

export class ListLoggedInPartnerCompany implements Action {
  readonly type = CrimpCloudPartnerActionTypes.LIST_LOGGED_IN_PARTNER_COMPANY;
  constructor(public payload: CrimpCloudPartnerListRequest) { }
}

export class ListLoggedInPartnerCompanySuccess implements Action {
  readonly type = CrimpCloudPartnerActionTypes.LIST_LOGGED_IN_PARTNER_COMPANY_SUCCESS;

  constructor(public payload: any) { }
}

export class ListLoggedInPartnerCompanyFailed implements Action {
  readonly type = CrimpCloudPartnerActionTypes.LIST_LOGGED_IN_PARTNER_COMPANY_FAILED;

  constructor(public payload: any) { }
}

export class CreateCrimpCloudPartners implements Action {
  readonly type = CrimpCloudPartnerActionTypes.CREATE_CRIMP_CLOUD_PARTNERS;
  constructor(public payload: CrimpCloudPartner) { }
}

export class CreateCrimpCloudPartnersSuccess implements Action {
  readonly type = CrimpCloudPartnerActionTypes.CREATE_CRIMP_CLOUD_PARTNERS_SUCCESS;

  constructor(public payload: any) { }
}

export class CreateCrimpCloudPartnersFailed implements Action {
  readonly type = CrimpCloudPartnerActionTypes.CREATE_CRIMP_CLOUD_PARTNERS_FAILED;

  constructor(public payload: any) { }
}

export class DeleteCrimpCloudPartners implements Action {
  readonly type = CrimpCloudPartnerActionTypes.DELETE_CRIMP_CLOUD_PARTNERS;
  constructor(public payload: CrimpCloudPartnerDeleteReq) { }
}

export class DeleteCrimpCloudPartnersSuccess implements Action {
  readonly type = CrimpCloudPartnerActionTypes.DELETE_CRIMP_CLOUD_PARTNERS_SUCCESS;

  constructor(public payload: any) { }
}

export class DeleteCrimpCloudPartnersFailed implements Action {
  readonly type = CrimpCloudPartnerActionTypes.DELETE_CRIMP_CLOUD_PARTNERS_FAILED;

  constructor(public payload: any) { }
}

export class ResetCrimCloudPartnersFlags implements Action {
  readonly type = CrimpCloudPartnerActionTypes.RESET_CRIMP_CLOUD_PARTNERS;
}

export class ResetPartnerCreationFlags implements Action {
  readonly type = CrimpCloudPartnerActionTypes.RESET_PARTNER_CREATION_FLAGS;
}

export class ResetPartnerDeletionFlags implements Action {
  readonly type = CrimpCloudPartnerActionTypes.RESET_PARTNER_DELETION_FLAGS;
}

export class ResetCrimpCloudPartnerList implements Action {
  readonly type = CrimpCloudPartnerActionTypes.RESET_CRIMP_CLOUD_PARTNER_LIST;
}


export type CrimpCloudPartnerActions =
  | ListCrimpCloudPartners
  | ListCrimpCloudPartnersSuccess
  | ListCrimpCloudPartnersFailed
  | ListLoggedInPartnerCompany
  | ListLoggedInPartnerCompanySuccess
  | ListLoggedInPartnerCompanyFailed
  | CreateCrimpCloudPartners
  | CreateCrimpCloudPartnersSuccess
  | CreateCrimpCloudPartnersFailed
  | DeleteCrimpCloudPartners
  | DeleteCrimpCloudPartnersSuccess
  | DeleteCrimpCloudPartnersFailed
  | ResetCrimCloudPartnersFlags
  | ResetPartnerCreationFlags
  | ResetPartnerDeletionFlags
  | ResetCrimpCloudPartnerList;
